(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-colourways"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ij-colourway-switcher').forEach(function (root) {
    var stage = root.querySelector('[data-colourway-stage]');
    var triggers = root.querySelectorAll('[data-colourway-trigger]');
    var images = root.querySelectorAll('[data-colourway-image]');
    var nameEl = root.querySelector('[data-colourway-name]');
    var priceEl = root.querySelector('[data-colourway-price]');
    var ctaEl = root.querySelector('[data-colourway-cta]');
    var currentName = nameEl ? nameEl.textContent : '';
    var currentVariantId = triggers.length ? triggers[0].getAttribute('data-variant-id') : null;
    var isMobile = function () {
      return window.matchMedia('(max-width: 749px)').matches;
    };
    var isSyncingScroll = false;

    function selectVariant(id, scrollStage) {
      var trigger = null;
      currentVariantId = id;

      triggers.forEach(function (t) {
        var active = t.getAttribute('data-variant-id') === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) trigger = t;
      });

      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-variant-id') === id);
      });

      if (trigger) {
        currentName = trigger.getAttribute('data-name');
        if (nameEl) nameEl.textContent = currentName;

        if (priceEl) {
          var price = trigger.getAttribute('data-price');
          priceEl.innerHTML = price
            ? '<span class="value">' + price + '</span><span class="ij-mono caption">On the road</span>'
            : '';
        }
      }

      if (scrollStage && stage && isMobile()) {
        var img = stage.querySelector('[data-variant-id="' + id + '"]');
        if (img) {
          isSyncingScroll = true;
          img.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          window.setTimeout(function () {
            isSyncingScroll = false;
          }, 400);
        }
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        selectVariant(trigger.getAttribute('data-variant-id'), true);
      });
    });

    if (stage && images.length > 1) {
      var scrollTimeout;
      stage.addEventListener(
        'scroll',
        function () {
          if (isSyncingScroll || !isMobile()) return;
          window.clearTimeout(scrollTimeout);
          scrollTimeout = window.setTimeout(function () {
            var stageRect = stage.getBoundingClientRect();
            var stageCenter = stageRect.left + stageRect.width / 2;
            var closest = null;
            var closestDistance = Infinity;

            images.forEach(function (img) {
              var rect = img.getBoundingClientRect();
              var imgCenter = rect.left + rect.width / 2;
              var distance = Math.abs(imgCenter - stageCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closest = img;
              }
            });

            if (closest) {
              selectVariant(closest.getAttribute('data-variant-id'), false);
            }
          }, 120);
        },
        { passive: true }
      );
    }

    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        var orderVariantSelect = document.querySelector('[data-order-variant]');
        if (orderVariantSelect && currentVariantId) {
          orderVariantSelect.value = currentVariantId;
          orderVariantSelect.dispatchEvent(new Event('change'));
          return;
        }

        var textarea = document.querySelector('[data-enquiry-body]');
        if (!textarea) return;
        var productTitle = ctaEl.getAttribute('data-product-title') || '';
        var suffix = currentName ? ' — ' + currentName : '';
        textarea.value = "I'm interested in the " + productTitle + suffix + '. Please get in touch with more information.';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ij-pdp-gallery').forEach(function (root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-trigger]'));
    var lightbox = root.querySelector('[data-gallery-lightbox]');
    if (!triggers.length || !lightbox) return;

    var lightboxImg = lightbox.querySelector('[data-gallery-lightbox-img]');
    var lightboxCaption = lightbox.querySelector('[data-gallery-lightbox-caption]');
    var closeBtn = lightbox.querySelector('[data-gallery-close]');
    var prevBtn = lightbox.querySelector('[data-gallery-prev]');
    var nextBtn = lightbox.querySelector('[data-gallery-next]');
    var currentIndex = 0;

    function show(index) {
      currentIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[currentIndex];
      var img = trigger.querySelector('img');
      var caption = trigger.getAttribute('aria-label') || '';
      lightboxImg.src = img ? img.currentSrc || img.src : '';
      lightboxImg.alt = caption;
      lightboxCaption.textContent = caption.indexOf('Open image') === 0 ? '' : caption;
    }

    function open(index) {
      show(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () {
        open(i);
      });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () {
      show(currentIndex - 1);
    });
    nextBtn.addEventListener('click', function () {
      show(currentIndex + 1);
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIndex - 1);
      if (e.key === 'ArrowRight') show(currentIndex + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-order-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-order-form]').forEach(function (form) {
    var variantSelect = form.querySelector('[data-order-variant]');
    var otrEl = form.querySelector('[data-order-otr]');
    var errorEl = form.querySelector('[data-order-error]');
    var submitBtn = form.querySelector('[data-order-submit]');
    var submitLabel = form.querySelector('[data-order-submit-label]');
    var defaultLabel = submitLabel ? submitLabel.textContent : '';

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (otrEl) otrEl.textContent = opt.getAttribute('data-price') || '';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Adding to cart…';

      var deliveryInput = form.querySelector('input[type="radio"]:checked');
      var notes = form.querySelector('[data-order-notes]');

      var items = [
        {
          id: parseInt(variantSelect.value, 10),
          quantity: 1,
          properties: {
            Delivery: deliveryInput ? deliveryInput.value : '',
            Notes: notes && notes.value ? notes.value : ''
          }
        }
      ];

      var accessoriesSelect = form.querySelector('[data-order-accessories]');
      if (accessoriesSelect) {
        Array.prototype.forEach.call(accessoriesSelect.selectedOptions, function (option) {
          items.push({ id: parseInt(option.value, 10), quantity: 1 });
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart-add-failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (errorEl) errorEl.hidden = false;
          if (submitBtn) submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = defaultLabel;
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
